import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA, } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { NgForm } from '@angular/forms';
import { AlertDialogComponent } from '../alert-dialog/alert-dialog.component';
import { Usuario } from 'src/app/models/usuario/usuario.model';
import { PrestamoAbonoService } from 'src/app/services/prestamo-abono/prestamo-abono.service';
import { ConfirmationDialog } from '../confirmation-dialog/confirmation-dialog.component';
import Swal from 'sweetalert2';
import { Alert } from 'selenium-webdriver';


export interface DialogData {

  idPlanPago: any
  archivos: any
  idPostulacion: any
  montoSolicitado: any
  rutUsuario: any
  nombreUsuario: any
  apellidoUsuario: any
  rol: any
  recarga: boolean
  cantidadCuotas: any
  idCodeudor1: any
  idCodeudor2: any
  idPrestamo: any
  tipoPrestamo: any
  idTipoPrestamo: any
  montoCuota: any
  montoTotalCuota: any
  fechaPrimerPago: any
  deshabilitado: boolean
  presionaEditar: boolean
  mostrarEditar: any
  disponiblePago: any
  idCantidadCuota: any,
  mostrarAprobarButton: any
  rutCodeudor1: any
  nombreCodeudor1: any
  apellidoCodeudor1: any
  rutCodeudor2: any
  nombreCodeudor2: any
  apellidoCodeudor2: any
  totalMaximo: any
  idUsuario: any
  tipos: any
  cuotas: any
  planes: any
  numCuota: any
  tasaInteres: any
  valorCuota: any
  totalCuota: any
  mostrarPago: any
}

declare const Rut: any;
@Component({
  selector: 'app-prestamos',
  templateUrl: '../../pages/prestamo-abono/prestamo-pago.html',
  styleUrls: ['../../pages/prestamo-abono/prestamo-abono.component.css']
})
export class DialogPagoPrestamo implements OnInit {

  prestamos: any
  planes: any
  user: any
  rol: string = localStorage.getItem("rol")
  config: any = { itemsPerPage: 5, currentPage: 1, totalItems: 5, indexInicial: 0, indexMaximo: 5 }
  configPlan: any = { itemsPerPage: 10, currentPage: 1, totalItems: 10, indexInicial: 0, indexMaximo: 10 }
  tipoPostulacion: string = "Pagadas"
  allComplete: boolean = false
  prestamoSolicitado: any
  idEjecutivo = localStorage.getItem("idUsuario")
  nombreUsuario: any
  rutUsuario: any
  totalMaximo: any
  //router : any
  cantidadArchivos = 1
  deshabilitado: true
  afiliado: any = { rutAfiliado: '', idAfiliado: '', nombreAfiliado: '', apellidoAfiliado: '' };

  pagoPrestamo: any = {
    montoSolicitado: this.data.montoSolicitado,
    idPostulacion: this.data.idPostulacion,
    idPrestamo: this.data.idPrestamo,
    cantidadCuotas: this.data.numCuota,
    idUsuario: localStorage.getItem("idUsuario"),
    idPlanPago: this.data.idPlanPago,
    idAfiliado: this.data.idUsuario, idCodeudor1: this.data.idCodeudor1,
    idCodeudor2: this.data.idCodeudor2, tipoPrestamo: this.data.tipoPrestamo,
    archivo: [], archivoTest: null,
    planes: []
  }

  constructor(public router: Router, public dialogRef: MatDialogRef<DialogPagoPrestamo>, private dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: DialogData, private prestamoAbonoService: PrestamoAbonoService,) {
    this.data.recarga = false
   

  }

  ngOnInit(): void {
    this.loadData()
  }

  loadData() {

  }

  pageChanged(event: any) {
    this.config.currentPage = event

    this.config.indexInicial = ((this.config.currentPage - 1) * this.config.itemsPerPage)
    this.config.indexMaximo = (this.config.currentPage * this.config.itemsPerPage)
  }

  openAlertDialog(mensaje: string, clase: string) {
    this.dialog.open(AlertDialogComponent, {
      data: { message: mensaje, clase: clase, buttonText: { cancel: 'Listo!' }, }
    })
  }



  salir() { this.router.navigate(['/index']) }

  seleccionaArchivo(event: any, numero: number) {
    if (event.target.files.length > 0) {

      let vm = this
      let reader = new FileReader()
      this.pagoPrestamo.archivo[0] = { url: "", archivo: reader.result, extension: event.target.files[0].type, size: event.target.files[0].size }
      reader.readAsDataURL(event.target.files[0])

      reader.onload = function () {
        vm.pagoPrestamo.archivo[0] = { url: "", archivo: reader.result, extension: event.target.files[0].type, size: event.target.files[0].size }
      }
    }
  }



  onCancelarClick(idPrestamo) {  

    this.dialogRef.afterClosed().subscribe(() => {
      this.data.recarga = false
      if (this.data.recarga) {
        this.verPlanPago(idPrestamo)
        this.loadData()
      }
    })
    Swal.close();

    this.dialogRef.close()
  }

  verPlanPago(idPrestamo: any) {

    this.prestamoAbonoService.traePlanPago(idPrestamo).then(
      planes => {
        this.planes = planes
      }
    ).catch(error => console.log(error))

  }


  onAgregarPagoClick(form: NgForm) {
    let vm = this;
    if (this.pagoPrestamo.archivoTest == null) {
      this.openAlertDialog('Por favor, adjunte un comprobante de pago', 'btn-danger')
      Swal.close();
      return false
    } else {

      const dialogRef = this.dialog.open(ConfirmationDialog,
        {
          data: { message: '¿Esta seguro de Ingresar la Solicitud de Pago?', buttonText: { ok: 'Si', cancel: 'No' } }
        })
      dialogRef.afterClosed().subscribe((confirmed: boolean) => {
        if (confirmed) {
          Swal.fire({
            allowOutsideClick: false,
            icon: 'info',
            text: 'Cargando...'
          });
          Swal.showLoading();

          let sizeArchivos = 0;
          for (let i = 0; i < this.cantidadArchivos; i++) {
            sizeArchivos += this.pagoPrestamo.archivo[i].size;
            if (sizeArchivos > 25000000) {
              this.openAlertDialog('Los archivos no deben sobrepasar 25mb en total', 'btn-danger')
              Swal.close();
              return;
            }
            this.pagoPrestamo.archivo[i].sizeArchivos;
            if (this.pagoPrestamo.archivo[i].extension != "application/pdf" && this.pagoPrestamo.archivo[i].extension != "image/jpeg" &&
              this.pagoPrestamo.archivo[i].extension != "image/jpg" && this.pagoPrestamo.archivo[i].extension != "image/png") {
              this.openAlertDialog('El archivo ' + (i + 1) + ' debe ser de tipo no modificable (PDF, PNG, JPEG, JPG)', 'btn-danger')

              Swal.close();
              return false
            }

          }

          this.prestamoAbonoService.ingresarPago(localStorage.getItem("idUsuario"), this.pagoPrestamo).then(
            () => {
              this.pagoPrestamo.archivo = [];
              this.openAlertDialog('La solicitud de pago de Préstamo fue ingresada exitosamente, aún debe ser validado.', 'btn-success')
              form.reset();
              this.verPlanPago(this.pagoPrestamo.idPrestamo)

              this.dialogRef.close()
              Swal.close();

            }
          )
            .catch(error => {
              console.log(error)
              Swal.close();
              this.openAlertDialog('Ha ocurrido un error al ingresar un pago.', 'btn-danger')
            })
        }
      })

    }

  }

  reloadComponent() {
    let currentUrl = this.router.url;
    this.router.routeReuseStrategy.shouldReuseRoute = () => false;
    this.router.onSameUrlNavigation = 'reload';
    this.router.navigate([currentUrl]);
  }


}